<template>
  <div>
    <a @click="open">
      <font-awesome-icon icon="cog" />
    </a>
    <el-dialog
        style="font-weight: normal;"
        :visible.sync="isOpen"
        top="50px"
        :close-on-click-modal="false"
        @close="cancel()">
      <div slot="title">
        <div class="el-dialog__title">
          Manage devices - Location <b>{{ locationName }}</b>
        </div>
      </div>
      <div class="user-info-card">
        <h2 class="section-title">
          Customer
        </h2>
        <p class="user-info">
          <span class="icon-row"><font-awesome-icon icon="user" /></span>
          <span class="user-detail">{{ fullName }}</span>
        </p>
        <p class="user-info">
          <span class="icon-row"><font-awesome-icon icon="envelope" /></span>
          <span class="user-detail">{{ currentUser.email }}</span>
        </p>
        <p class="user-info">
          <span class="icon-row"><font-awesome-icon icon="phone" /></span>
          <span
              class="user-detail"
              :class="{'disabled': !currentUser.phone_number}">
            {{ currentUser.phone_number || 'no data available' }}
          </span>
        </p>
        <hr>
        <h2 class="section-title">
          Devices
        </h2>
        <div
            v-for="device in allDevices"
            :key="device.doorbot_id"
            class="device-rows">
          <device-user-row
              :auth="device" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DeviceUserRow from "./DeviceUserRow";
import { get, isEmpty, cloneDeep } from "lodash";

import { createNamespacedHelpers as h } from "vuex";
const { mapGetters: sharedGetters } = h("shared");

export default {
  name: "AddUserLocation",
  components: { DeviceUserRow },
  props: {
    userId: {
      required: true,
      type: [String, Number],
    },
    location: {
      required: true,
      type: Object,
      default: () => {
        return {};
      },
    },
    devices: {
      required: true,
      type: Array,
      default: () => {
        return [];
      },
    },
    users: {
      required: true,
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      userIdent: this.userId,
      currentUser: {},
      isOwner: this.location.owner_id == this.userId,
      locationId: this.location.location_id,
      locationName: this.location.name,
      userDevices: [],
      allDevices: [],
      isOpen: false,
    };
  },
  computed: {
    ...sharedGetters(["products"]),
    fullName() {
      return `${this.currentUser.first_name} ${this.currentUser.last_name}`;
    },
  },
  created() {
    this.currentUser = this.users.find((u) => {
      return u.user_id === this.userIdent;
    });
    this.userDevices = get(this.currentUser, "devices", []);
    this.allDevices = this.prepareAssignment();
  },
  methods: {
    open() {
      this.isOpen = true;
      this.$emit("selected", true);
    },
    cancel() {
      this.isOpen = false;
    },
    getProduct(kind) {
      return this.products.find((p) => p.kind == kind) || {};
    },
    updateAuth(auth) {
      console.log("Auth updated", auth);
    },
    prepareAssignment() {
      let _user = this.currentUser;
      let _device_auths = [];
      let _isOwner = this.isOwner;

      this.devices.forEach((device) => {
        let currentDevice =
          this.userDevices.find((d) => {
            return d.doorbot_id === device.doorbot_id;
          }) || {};

        let auth = {
          doorbot_id: device.doorbot_id,
          mac_address: device.mac_address,
          name: device.name,
          product: this.getProduct(device.type),
          type: device.type,
          role: _isOwner ? "owner" : "shared_user",
          user_id: _user.id || _user.user_id,
          location_id: this.locationId,
          granted: !isEmpty(currentDevice),
        };
        _device_auths.push(cloneDeep(auth));
      });

      return Array.from(_device_auths);
    },
  },
};
</script>

<style scoped>
h2.section-title {
  margin: 15px 0px;
  color: #666;
}
.user-info-card {
  border-radius: 0px !important;
  box-shadow: none !important;
  padding: 0px 15px 20px 15px;
}
ul.device-rows {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
p.user-info {
  padding: 10px 0px;
}

p.user-info .user-detail {
  font-size: 18px;
  margin-left: 10px;
}
p.user-info .user-detail.disabled {
  color: #999;
}
p.user-info .icon-row {
  border: solid 1px #999;
  color: #999;
  border-radius: 100%;
  padding: 3px 6px;
}
</style>
